module.exports = __webpack_public_path__ + "static/media/face-with-open-mouth-svgrepo-com.53636bb8.svg";